module.exports = __webpack_public_path__ + "img/logo.53e47a0b.png";